import { pruRewards as pwa } from 'white-labelling/pru-rewards';

export default pwa;
